<template>
    <div v-if="ay_list!=null">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Copy Div Structure</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container>
                <v-row dense>
                    <v-col cols="12" sm="5" md="5" style="text-align: right;">
                        <v-combobox rounded dense required return-object v-model="from_ay" :items="ay_list"
                            item-text="ay" label="From Academic Year" outlined />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" style="text-align: center;">
                        <v-btn text color="#0f2027" :loading="copy_btn_load">
                            <v-icon large color="#0f2027">mdi-arrow-right-bold-circle</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="5" md="5" style="text-align: left;">
                        <v-combobox rounded dense required v-model="to_ay" return-object :items="ay_list" item-text="ay"
                            label="To Academic Year" outlined />
                    </v-col>
                </v-row>
                <v-row dense justify="center">
                    <v-col cols="12" sm="5" md="5" style="text-align: left;">
                        <v-combobox rounded dense required v-model="standard" return-object :items="standard_list"
                            item-text="standard" label="Select Standard" outlined />
                    </v-col>
                </v-row>
                <v-row dense justify="center">
                    <v-btn v-if="standard && to_ay" class="button" @click="getTeacher()">Fetch</v-btn>
                </v-row>
            </v-container>
        </v-card>

        <v-card class="box" v-if="teacher_list!=''">
            <v-data-table v-model="selectedTasks" item-key="did" :single-select="singleSelect" show-select
                :headers="headers" :items="teacher_list" dense sort-by="" class="elevation-1 mytable" :search="search">
            </v-data-table>
            <v-row dense justify="center">
                <v-btn :loading="copy_offer_btn_load" class="button" @click="copySubject()">Copy</v-btn>
            </v-row>
        </v-card>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },

        data: () => ({
            ay_list: null,
            to_ay: null,
            from_ay: null,
            from_slot_list: null,
            // extraBreadcrumbItems: [
              

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            to_slot_list: null,
            search: "",
            copy_btn_load: false,
            standard_list: [],
            singleSelect: false,
            selectedTasks: [],
            standard: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            filterArr: [],
            copy_offer_btn_load:false,
            filters: {
                subjectcode: [],
                subject: [],
            },
            teacher_list: [],
            headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "Standard", value: "standard" },
                { text: "Division", value: "div" },
                { text: "Capacity", value: "capacity" },
                { text: "Steeam", value: "stream" },
                { text: "Class Teacher", value: "teacher" },
            ],
        }),
        computed: {
           
        },
        methods: {
            onLoad() {
                axios
                    .post("/Examination/getInitialData")
                    .then((res) => {
                        // this.to_ay = res.data.curreny_ay;
                        this.ay_list = res.data.ay_list;
                        //this.from_ay = res.data.curreny_ay;
                        this.standard_list = res.data.standard_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        //close loader
                        this.copy_offer_btn_load = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            copySubject() {
                if (this.selectedTasks == "") {
                    this.showSnackbar("#b71c1c", "Please select Subject");
                }
               // console.log(this.selectedTasks)
                this.copy_offer_btn_load = true
                 const data = {
                    teacher_id: this.selectedTasks,
                    from_ay: this.from_ay.id,
                    to_ay: this.to_ay.id,
                    standard: this.standard.id,
                };
                  axios
                    .post("/Admission/copyTeacher", data)
                    .then((res) => {
                        this.showSnackbar("#4caf50", "Subject Copied Successfully...");
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        //close loader
                        this.copy_offer_btn_load = false;
                        this.copy_offer_btn_load = false
                        this.teacher_list = []
                        this.singleSelect = false
                        this.selectedTasks = []
                        this.standard = null 
                        this.to_ay = null
                    });
            },
            getTeacher() {
                if (this.from_ay.id == this.to_ay.id) {
                    this.showSnackbar("#b71c1c", "From and To Academic year cannot be same!!!...")
                    return;
                }
                const formData = {
                    from_ay: this.from_ay,
                    standard: this.standard,
                };
                axios
                    .post("/Admission/getTeacher", formData)
                    .then((res) => {
                        this.teacher_list = res.data.teacher_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        //close loader
                        this.copy_offer_btn_load = false;
                    });
            },
        },
        mounted() {
            this.onLoad();
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
